import ValueGeneratorInterface from "./ValueGeneratorInterface"
import ValueInterface from "../../Model/Value/ValueInterface"
import SumValue from "../../Model/Value/SumValue"
import RandomNumberGenerator from "../RandomNumberGenerator"
import NumberValue from "../../Model/Value/NumberValue"

export default class SumValueGenerator implements ValueGeneratorInterface {
  constructor(private readonly randomNumberGenerator: RandomNumberGenerator) {}

  public supports(value: number, level: number): boolean {
    return level < 6 && value > 1
  }

  public generate(value: number): ValueInterface {
    const left: number = this.randomNumberGenerator.randomInt(1, value - 1)

    return new SumValue(new NumberValue(left), new NumberValue(value - left))
  }
}
